import { Injectable } from '@angular/core';
import { IRuntimeConfig } from '@redngapps/feature-flags/env/types';
import { AbstractRuntimeConfigService } from '@redngapps/shared/runtime-config/data-access';

/**
 * Holds the per-instance runtime config for the Feature-Flags admin app. Populated once during
 * `APP_INITIALIZER` (see {@link RuntimeConfigInitializerService}); storage lives in the shared base.
 */
@Injectable({ providedIn: 'root' })
export class RuntimeConfigService extends AbstractRuntimeConfigService<IRuntimeConfig> {}
